import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d9fc562c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  class: "header",
  src: "https://static-jp.theckb.com/static-asset/client/listTitle1.png",
  alt: ""
}
const _hoisted_3 = { class: "rel search-input" }
const _hoisted_4 = {
  key: 0,
  for: "upload_image",
  class: "flex-ter"
}

import { ref, reactive, watch, onMounted } from 'vue'
import { t } from '@/plugins/i18n'
import { Search, Camera } from '@element-plus/icons-vue'
import { useRtfix } from '@/store'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { searchByImage, searchByBase64 } from '@/util/useSearchByImage'
import { TaEvent, taTrack } from '@/util/buryingPoint'
import { bury } from '@/util/useBury'

export default /*#__PURE__*/_defineComponent({
  props: ['noBanner'],
  setup(__props) {

const props = __props

const store = useStore()
/** 搜索关键词 */
const keyword = ref('')
const searchRef = ref()
const buss = reactive(store.state.bussiness)
const router = useRouter()
const route = useRoute()

const reset = (clear: boolean | void) => {
  store.commit('bussiness/sortType', '')
  // store.commit('bussiness/productCategoryFrontendId', '')
  store.commit('bussiness/sellPriceStart', '')
  store.commit('bussiness/sellPriceEnd', '')
  store.commit('bussiness/RESET_CONDITION')
  if (clear) {
    keyword.value = ''
  }
}

const clickPic = () => {
  bury('ALL_Click_SearchByImage1')
  taTrack({
    event: TaEvent.BTN_CLICK,
    value: {
      position: '1688_photo_search'
    }
  })
}

const categrayList = [
  { label: t('全部'), value: '0' },
  { label: 'レディースファッション', value: '10166' },
  { label: 'メンズファッション', value: '10165' },
  { label: '子供服', value: '311' },
  { label: 'インテリア', value: '96' },
  { label: 'スポーツ＆アウトドア', value: '18' },
  { label: 'ペット用品', value: '122916001' },
  { label: 'キッチン用品', value: '201547801' },
  { label: 'バッグ', value: '1042954' },
  { label: '収納', value: '1548' },
  { label: 'アクセサリー', value: '54' },
  { label: 'スマホ＆パソコン', value: '7' },
  { label: '車用品', value: '122916002' }
]

/** 搜索关键词 */
const handleSearch = () => {
  const categoryId = route.query.categoryId
  taTrack({
    event: TaEvent.PRODUCT_SEARCH_1688,
    value: {
      search_content: keyword.value,
      category_name: categrayList.find(i => i.value === categoryId)?.label
    }
  })
  const kw = keyword.value.trim()
  searchRef.value.blur()
  let query: any = { filters: route.query }
  buss.keyword = kw
  query = { ...store.getters['bussiness/model'], keyword: kw, _t: Date.now(), national: 1, categoryId: route.query.categoryId || '0' }
  if (query.channel === '0') {
  } else {
    query.schannel = query.channel
  }
  delete query.channel
  reset()

  router[route.name?.toString().includes('list') ? 'replace' : 'push'](
    useRtfix('list', { query })
  )
}

const regPath = (path: string) => {
  const reg = new RegExp('(ja|ko)/(' + path + ')')
  return reg.test(route.path as string)
}

watch(() => route.query.keyword, (val) => {
  if (!regPath('index/ecommerce')) {
    val && (keyword.value = String(val))
  }
}, { immediate: true })

// 图搜
const uploadImageRef = ref()
const choosePic = (e: any) => {
  const file = e.target.files[0]
  // 清空一下这个input的值不然选同一个文件不触发事件
  uploadImageRef.value.value = ''
  searchByImage(file).then(() => {
    reset(true)
  })
}
onMounted(() => {
  if (!props.noBanner) {
    taTrack({
      event: TaEvent.PAGE_VIEW,
      value: {
        position: '1688_search_page'
      }
    })
  }
})


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("img", _hoisted_2, null, 512), [
      [_vShow, !__props.noBanner]
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_input, {
        class: "elInput",
        ref: (_value, _refs) => {
          _refs['searchRef'] = _value
          searchRef.value = _value
        },
        placeholder: _unref(t)('搜索1688国家专属严选货盘 所有产品品质保障'),
        type: "text",
        maxlength: "500",
        modelValue: keyword.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
        title: keyword.value,
        "prefix-icon": _unref(Search)
      }, {
        suffix: _withCtx(() => [
          (_unref(buss).schannel !== '1')
            ? (_openBlock(), _createElementBlock("label", _hoisted_4, [
                _createElementVNode("i", {
                  class: "iconfont icon-search_camera1 ico-btn",
                  onClick: clickPic,
                  style: {"cursor":"pointer","font-size":"14px"}
                }),
                _withDirectives(_createElementVNode("input", {
                  id: "upload_image",
                  type: "file",
                  ref: (_value, _refs) => {
                    _refs['uploadImageRef'] = _value
                    uploadImageRef.value = _value
                  },
                  onChange: choosePic,
                  accept: "image/gif,image/png,image/jpeg,image/bmp,image/jpg"
                }, null, 544), [
                  [_vShow, false]
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["placeholder", "modelValue", "title", "prefix-icon"]),
      _createElementVNode("div", {
        class: "search-btn",
        onClick: handleSearch
      }, _toDisplayString(_unref(t)('搜索')), 1)
    ])
  ]))
}
}

})